import CLPViewState from '../store/schema/CLPViewState';
import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';
import getCLPLabelMethod from './getCLPLabelMethod';
import extendedPropertyType from 'owa-service/lib/factory/extendedPropertyType';
import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import Message from 'owa-service/lib/contract/Message';
import { now, getISOString } from 'owa-datetime';
import { logCLPComposeUsage } from '../utils/logCLPDatapoints';
import { LABEL_PROPERTY_NAME, LABEL_MODIFY_HEADER, EMPTY_LABEL_GUID } from '../utils/constants';

const CLP_LABEL_PREFIX = 'MSIP_Label';

interface LabelStamp {
    Enabled: string;
    SiteId: string;
    SetDate: string;
    Name: string;
    ContentBits: number;
    Method: string;
}

export default function stampCLPLabelInExtendedProperty(clpViewState: CLPViewState, item: Message) {
    const tenantId = getUserConfiguration().SessionSettings.ExternalDirectoryTenantGuid;

    let { selectedCLPLabel, originalCLPLabel, nonTenantLabelString } = clpViewState;

    addLabelModifyHeader(selectedCLPLabel, originalCLPLabel, item);

    if (!selectedCLPLabel && !nonTenantLabelString) {
        return;
    }

    let selectedLabelString = '';
    if (selectedCLPLabel) {
        const labelSetDate = getISOString(now());
        const labelNameToStamp = selectedCLPLabel.displayName;

        const labelStampObj: LabelStamp = {
            Enabled: 'True',
            SiteId: tenantId,
            SetDate: labelSetDate,
            Name: labelNameToStamp,
            ContentBits: 0,
            Method: getCLPLabelMethod(clpViewState),
        };
        selectedLabelString = getLabelStampString(labelStampObj, selectedCLPLabel);
    }

    // This string will be in following format:
    // MSIP_LABEL_<labelId>_<propertyName>=<propertyValue>;MSIP_LABEL_<labelId>_<propertyName>=<propertyValue>
    const labelPropertyValue = nonTenantLabelString
        ? nonTenantLabelString + selectedLabelString
        : selectedLabelString;

    addExtendedPropertyToItem(LABEL_PROPERTY_NAME, labelPropertyValue, item);

    logCLPComposeUsage(selectedCLPLabel);
}

function addLabelModifyHeader(selectedLabel: CLPLabel, originalLabel: CLPLabel, item: Message) {
    if (!selectedLabel && !originalLabel) {
        //If there are neither of the labels exist, there is no change of labels
        //Skip
        return;
    }

    if (selectedLabel && originalLabel && selectedLabel.id == originalLabel.id) {
        //If both label exist and they are the same label, there is no change of labels
        //Skip
        return;
    }

    //The header value format for modifying label is --> <fromLabel>;<toLabel>
    let headerValue = `${originalLabel ? originalLabel.id : EMPTY_LABEL_GUID};${
        selectedLabel ? selectedLabel.id : EMPTY_LABEL_GUID
    }`;

    addExtendedPropertyToItem(
        LABEL_MODIFY_HEADER /*PropertyName*/,
        headerValue /*PropertyValue*/,
        item
    );
}

function addExtendedPropertyToItem(propertyName: string, value: string, item: Message): void {
    const extendedProperty = extendedPropertyType({
        ExtendedFieldURI: extendedPropertyUri({
            PropertyName: propertyName,
            DistinguishedPropertySetId: 'InternetHeaders',
            PropertyType: 'String',
        }),
        Value: value,
    });

    if (item.ExtendedProperty) {
        item.ExtendedProperty.push(extendedProperty);
    } else {
        item.ExtendedProperty = [extendedProperty];
    }
}

function getLabelStampString(labelStampObj: LabelStamp, selectedCLPLabel: CLPLabel): string {
    let stampString = '';
    stampString = Object.keys(labelStampObj)
        .map(key => {
            return `${CLP_LABEL_PREFIX}_${selectedCLPLabel.id}_${key}=${labelStampObj[key]};`;
        })
        .join('');
    return stampString;
}
